import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Formik } from "formik";
import * as Yup from "yup";
import { useNavigate, useSearchParams } from "react-router-dom";
import { login } from "../../../store/authMethods";
import { useDispatch } from "react-redux";
import { useState } from "react";
import ForgetPassword from "./ForgetPassword"

const LoginSchema = Yup.object().shape({
  password: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Password is required."),
  username: Yup.string().required("Email or phone number is required."),
});

function Login({ setShow, show }) {
  const handleClose = () => setShow(false);
  const navigate = useNavigate();
  const [passwordShow, setPasswordShow] = useState(false);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const action = searchParams.get("action");
  useEffect(() => {
    if (action === "login") {
      setShow(true);
    }
  }, []);

  console.log(passwordShow, "show");

  return (
    <Modal centered show={show} onHide={handleClose}>
      {/* closeButton */}
      <Modal.Header className="px-5 py-4 border-0">
        <Modal.Title as="h2" className="regular">
          Sign In
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-5 pt-0">
        <Formik
          initialValues={{
            username: "",
            password: "",
            grant_type: "password",
            client_id: process.env.REACT_APP_CLIENT_ID,
          }}
          validationSchema={LoginSchema}
          onSubmit={(values, { setSubmitting }) => {
            dispatch(login(values, navigate, handleClose));
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <div>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-4">
                  <Form.Control
                    type="text"
                    placeholder="Email or phone number"
                    name="username"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.username || ""}
                  />
                  {errors.username && touched.username && (
                    <small className="text-danger">{errors.username}</small>
                  )}
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    name="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password || ""}
                  />
                  {errors.password && touched.password && (
                    <small className="text-danger">{errors.password}</small>
                  )}
                </Form.Group>
                <div className="d-flex align-items-center">
                  <Form.Group className="mb-4" controlId="remember">
                    <Form.Check
                      type="checkbox"
                      name="remember"
                      label="Remember me"
                    />
                  </Form.Group>
                  <Button
                    variant="link"
                    onClick={() => {
                      setPasswordShow(true);
                      // setShow(false);
                    }}
                    className="mb-4 ms-auto"
                  >
                    Forget Password
                  </Button>
                </div>

                <div className="d-grid">
                  <Button
                    variant="primary"
                    size="lg"
                    type="submit"
                    className="shadow"
                    disabled={isSubmitting}
                  >
                    {!isSubmitting ? "Sign In" : "Signing In..."}
                  </Button>
                </div>
              </Form>
              {passwordShow && (
                <ForgetPassword
                  passwordShow={passwordShow}
                  setPasswordShow={setPasswordShow}
                />
              )}
            </div>
          )}
        </Formik>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleClose}>
          Save Changes
        </Button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default Login;
